export default "/assets/images/mama-hero.b3d63fb3177f99cc.png";